module.exports = __webpack_public_path__ + "img/TD.967009d4.png";